import axios from 'axios';
import { AuthContextValue } from '@/contexts/auth';
import { API_PREFIX } from '@/constants';
import { TaskStatus } from '../add-friend-tasks';
import { queryTaskSummary } from '../add-friend-tasks/service'
import { querySOPCountInfo } from '../sop/service';
// import { MomentsStatus } from '../moments/constants';
// import { queryMomentsSummary } from  '../moments/service'


export const queryUnreadCounts = async (auth: AuthContextValue) => {
  const { corpId, userId } = auth;
  const { [TaskStatus.excuting]: { customersCount } } = await queryTaskSummary(auth);
  const res = await axios.get<number>(`${API_PREFIX.CUSTOMER}/customerDynamic/getPendingCount`, { params: { corpId, userId } });
  const { pendingTotalCount = 0 } = await querySOPCountInfo(auth) || {};
  // const { [MomentsStatus.NO_SEND]: momentsCount } = await queryMomentsSummary(auth);
  return {
    task: customersCount,
    reminder: res.data,
    sop: pendingTotalCount,
    // moments: momentsCount,
  };
}
